/** Quila DB table names — single source of truth for admin UI */
export const AppTable = {
  USERS: "app_users",
  BUSINESSES: "app_businesses",
  PRODUCTS: "app_products",
  PRODUCT_IMAGES: "app_product_images",
  POSTS: "app_posts",
  POST_MEDIA: "app_post_media",
  REVIEWS: "app_reviews",
  REVIEW_MEDIA: "app_review_media",
  COMMENTS: "app_comments",
  CONTENT_MODERATIONS: "app_content_moderations",
  CONTENT_REPORTS: "app_content_reports",
} as const;

export const APP_TABLE_PREFIX = "app_";

export type AppTableValue = (typeof AppTable)[keyof typeof AppTable];
